module.exports = __webpack_public_path__ + "img/10.6a49141c.jpg";